import * as authHelper from '../src/features/auth/utils/token';
import './styles/fonticon/fonticon.css';
import './styles/keenicons/duotone/style.css';
import './styles/keenicons/outline/style.css';
import './styles/keenicons/solid/style.css';
import './styles/sass/plugins.scss';
import './styles/sass/style.react.scss';

/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './styles/sass/style.scss';
import { ApiError } from 'api/generated';
import { AuthProvider } from 'features/auth/contexts/auth';
import { setupHttp, setupHttpNew } from 'features/auth/utils/http';
import { AppI18nProvider } from 'i18n/contexts/app';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryCache, QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { AppRoutes } from 'routes/app-route';
import { ThemeModeProvider } from 'theme/contexts/theme';

const startVersionCheckPolling = () => {
  setInterval(() => {
    fetch('/meta.json', { cache: 'no-store' }).catch(() => {});
  }, 10 * 60 * 1000);
};

const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`/sw.js?v=${Date.now()}`)
        .then((registration) => {
          console.log('ServiceWorker registration successful with scope: ', registration.scope);

          startVersionCheckPolling();

          // Listen for messages from the service worker
          navigator.serviceWorker.addEventListener('message', (event) => {
            const data = event.data;
            if (data?.type === 'NEW_VERSION') {
              console.log('New version detected:', data);

              // Here you can react however you want, e.g., show a toast or prompt user to refresh
              alert('New version available!\nPlease reload the page to update.');

              // Optional: automatically reload page after notification
              // window.location.reload();
            }
          });
        })
        .catch((error) => {
          console.log('ServiceWorker registration failed: ', error);
        });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

setupHttp();
setupHttpNew();

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (error instanceof ApiError) {
        if (error?.status === 401) {
          // handle 401
          authHelper.removeAuth();
          if (!window.location.pathname.includes('/auth')) {
            const currentPath = window.location.pathname + window.location.search;
            const redirectUrl = currentPath ? `/auth?redirect=${encodeURIComponent(currentPath)}` : '/auth';
            window.location.href = redirectUrl;
          }
        }
      }
      if (query.state.data !== undefined) {
        // error toast can be here
      }
    }
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppI18nProvider>
        <ThemeModeProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </ThemeModeProvider>
      </AppI18nProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

registerServiceWorker();
